<template>
  <div>
    <jd-dialog
      class="ques-static-dialog"
      :title="titleText"
      :visible.sync="showDialog"
      width="918px"
      @close="onClose"
    >
      <div class="ques-static-content" v-loading="isLoading">
        <template v-if="questionData.length">
          <div v-for="(item, index) in questionData" :key="item.key">
            <div
              class="box-card"
              shadow="never"
              v-if="[1, 2, 4, 5, 7, 12].includes(item.type)"
            >
              <!-- 标题 -->
              <div class="queTitle">{{ index + 1 + "、 " + item.title }}</div>
              <!-- 1.单选题 和 2.多选题 -->
              <div class="ques-text-content" v-if="[1, 2, 12].includes(item.type)">
                <template v-if="item.type == 1 || item.type == 12">
                  <div
                    v-for="(optItem, optIndex) in item.options"
                    :key="optIndex"
                    class="queText"
                  >
                    <div class="flex-spc-x">
                      <div style="width: 220px">
                        {{
                          item.type == 12 ? optItem.description :
                            optionTitle(optIndex) + "、 " + optItem.description
                        }}
                      </div>
                      <div class="progress">
                        <span class="progress-num">{{
                          optItem.answerUserNum + "人选择"
                        }}</span>
                        <el-progress
                          v-if="item.total != 0"
                          :text-inside="false"
                          :percentage="Number(optItem.proportion.split('%')[0])"
                          style="width: 75%"
                        ></el-progress>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <el-table :data="item.options" border style="width: 100%">
                    <el-table-column
                      prop="title"
                      label="题目\选项"
                      width="150"
                      align="left"
                    >
                      <template #default="scope">
                        {{
                          optionTitle(scope.$index) +
                          "、 " +
                          scope.row.description
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column label="统计方式：人数占比" align="center">
                      <template #default="scope">
                        <div class="progress" style="width: 100%;">
                          <span class="progress-num">{{
                            scope.row.answerUserNum + "人选择"
                          }}</span>
                          <el-progress
                            v-if="item.total != 0"
                            :text-inside="false"
                            :percentage="
                              Number(scope.row.proportion.split('%')[0])
                            "
                            style="width: 75%"
                          ></el-progress>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="统计方式：选项次数占比" align="center">
                      <template #default="scope">
                        <div class="progress" style="width: 100%;">
                          <span class="progress-num">{{
                            scope.row.optionNum + "人选择"
                          }}</span>
                          <el-progress
                            v-if="item.total != 0"
                            :text-inside="false"
                            :percentage="
                              Number(
                                scope.row.optionNumProportion.split('%')[0]
                              )
                            "
                            style="width: 75%"
                          ></el-progress>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </div>
              <!-- 4. 图片单选 5.图片多选 -->
              <div
                class="ques-text-content ques-img-content"
                v-if="[4, 5].includes(item.type)"
              >
                <div
                  v-for="(optItem, optIndex) in item.options"
                  :key="optIndex"
                  class="queText"
                >
                  <div class="flex-spc-x">
                    <div class="flexc-cen-x" style="width: 30%">
                      <span>{{ optionTitle(optIndex) + "、 " }} </span>
                      <img
                        class="img"
                        mode="aspectFill"
                        :src="optItem.picUrl"
                        @click="handlePictureCardPreview(optItem.picUrl)"
                      />
                    </div>
                    <div class="progress">
                      <span class="progress-num">{{
                        optItem.answerUserNum + "人选择"
                      }}</span>
                      <el-progress
                        v-if="item.total != 0"
                        :text-inside="false"
                        :percentage="Number(optItem.proportion.split('%')[0])"
                        style="width: 75%"
                      ></el-progress>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 7 矩阵题 -->
              <div
                class="ques-text-content ques-matrix-content"
                v-if="[7].includes(item.type)"
              >
                <el-table :data="item.tableData" border style="width: 100%">
                  <el-table-column
                    prop="title"
                    label="题目\选项"
                    width="150"
                    align="left"
                  >
                    <template #default="scope">
                      {{ scope.row.rowDescription }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="colItem in item.optionsColumn"
                    :key="colItem.level"
                    :label="colItem.columnDescription"
                    align="center"
                  >
                    <template #default="scope">
                      <div>{{ getNum(scope.row, colItem) }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </template>
        <div
          v-else
          style="margin-top: 100px; font-size: 15px; text-align: center"
        >
          暂无统计数据
        </div>
      </div>
      <template #footer>
        <jd-button type="default" @click="onClose">取消</jd-button>
      </template>
    </jd-dialog>
  </div>
</template>

<script>
import { getQuestionSummary } from "@/api/jhk/questionnaire.js";
/**
 * 问卷统计
 */
export default {
  name: "questionnaireStatistics",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    activityId: {
      type: String,
      default: "",
    },
    titleText: {
      type: String,
      default: "问卷统计",
    }
  },
  data() {
    return {
      showDialog: false,
      questionData: [],
      isLoading: false,
    };
  },
  watch: {
    show(val) {
      this.showDialog = val;
      if (val) {
        this.questionData = [];
        this.getList();
      }
    },
  },
  methods: {
    async getList() {
      this.isLoading = true;
      const res = await getQuestionSummary({
        activityId: this.activityId,
      });
      this.isLoading = false;
      if (res.code == 1) {
        let list = res.data || [];
        list = list.filter((item) => [1, 2, 4, 5, 7, 12].includes(item.type));
        list.forEach((item) => {
          if (item.type == 7) {
            let options = item.options || [];
            let options10Column = [];
            let options10Row = [];
            options.forEach((optItem) => {
              let options10RowSort = options10Row.map((item1) => item1.sort);
              let options10ColumnLevel = options10Column.map(
                (item2) => item2.level
              );
              //行标题
              if (!options10RowSort.includes(optItem.sort)) {
                let filterColums = options.filter(
                  (fItem) => fItem.sort == optItem.sort
                );
                let rowObj = {
                  rowDescription: optItem.description.split(":")[0],
                  ...optItem,
                  options10Column: filterColums,
                };
                options10Row.push(rowObj);
              }
              if (!options10ColumnLevel.includes(optItem.level)) {
                let colObj = {
                  columnDescription: optItem.description.split(":")[1],
                  ...optItem,
                };
                options10Column.push(colObj);
              }
            });
            item.optionsColumn = options10Column;
            item.tableData = options10Row;
            console.log(item.tableData);
          }
        });
        this.questionData = list;
        // console.log("this.questionData>>", this.questionData);
      }
    },

    // 根据 index获取选项名称
    optionTitle(index) {
      switch (index) {
        case 0:
          return "A";
        case 1:
          return "B";
        case 2:
          return "C";
        case 3:
          return "D";
        case 4:
          return "E";
        case 5:
          return "F";
        case 6:
          return "G";
        case 7:
          return "H";
        case 8:
          return "I";
        case 9:
          return "J";
        case 10:
          return "K";
        case 11:
          return "L";
        case 12:
          return "M";
        case 13:
          return "N";
        case 14:
          return "O";
        case 15:
          return "P";
        case 16:
          return "Q";
        case 17:
          return "R";
        case 18:
          return "S";
        case 19:
          return "T";
        case 20:
          return "U";
        default:
          return "";
      }
    },

    getNum(row, colItem) {
      // console.log("row>>", row, colItem);
      let options10Column = row.options10Column;
      let filterItem = options10Column.find(
        (item) => item.level == colItem.level
      );
      let num = `${filterItem.answerUserNum}（${filterItem.proportion}）`;
      return num;
    },
    onClose() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog .el-dialog__body {
  padding: 20px 24px 15px !important;
}
/deep/ .el-progress-bar {
  padding-right: 65px;
  margin-right: -65px;
  .el-progress-bar__outer {
    height: 8px !important;
    background-color: rgba(0, 0, 0, 0.08) !important;
    .el-progress-bar__inner {
      background-color: #7b61ff !important;
    }
    .el-progress__text {
      font-size: 14px !important;
      color: #999999 !important;
    }
  }
}
.ques-static-dialog {
  .ques-static-content {
    min-height: 192px;
    max-height: 678px;
    height: auto;
    overflow-y: scroll;
    overflow-x: hidden;
    .box-card {
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #eeeeee;
      margin-bottom: 20px;
      .queTitle {
        padding: 16px 20px;
        background: #f8f9ff;
        font-size: 14px;
        color: #333333;
      }

      .ques-text-content {
        padding: 20px 20px;
        .queText {
          font-size: 14px;
          color: #333333;
          padding-bottom: 20px;
        }
        .queText:nth-last-child(1) {
          padding-bottom: 0px;
        }
        .img {
          width: 32px;
          height: 32px;
          border-radius: 2px 2px 2px 2px;
          display: block;
        }
      }
      .ques-text-content.ques-img-content {
        padding: 14px 20px;
        .queText {
          padding-bottom: 8px;
          &:nth-last-child(1) {
            padding-bottom: 0px;
          }
        }
      }
      .ques-text-content.ques-matrix-content {
        padding: 20px;
      }
    }
  }
}
.progress {
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: space-evenly;
}
.progre .progress-num {
  width: 25%;
  text-align: right;
  font-size: 14px;
  color: #999999;
  margin-right: 8px;
}
</style>
<style></style>
